import { isDev } from '~~/services/common';

export default defineNuxtPlugin(() => {
    // Enable logs only in dev, or when explicitly toggled via localStorage 'debug' = '1'
    let enabled = false;
    try {
        enabled = isDev() || (typeof window !== 'undefined' && localStorage.getItem('debug') === '1');
    } catch {}
    if (!enabled) return;

    const router = useRouter();

    router.beforeEach((to, from) => {
        // Basic navigation trace
        console.debug('[router] navigating', { from: from.fullPath, to: to.fullPath });
        return true;
    });

    router.afterEach((to, from, failure) => {
        if (failure) {
            console.error('[router] navigation failed', { from: from.fullPath, to: to.fullPath, failure });
        } else {
            console.debug('[router] navigated', { to: to.fullPath });
        }
    });

    // Capture unhandled errors in components during navigation/mount
    const app = useNuxtApp();
    app.vueApp.config.errorHandler = (err, instance, info) => {
        // Avoid noisy logs in dev SSR; only client plugin runs in browser
        console.error('[vue] errorHandler', { err, info, route: router.currentRoute.value.fullPath });
    };
});


